import { render, staticRenderFns } from "./OtchetType.vue?vue&type=template&id=ba5434a2"
import script from "./OtchetType.vue?vue&type=script&lang=js"
export * from "./OtchetType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports